import { forwardRef } from 'react';
import { getFieldContainerStyles } from './FieldContainerStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const FieldContainer = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    isFocused = false,
    disabled = false,
    isInvalid = false,
    readOnly = false,
    ...rest
  } = _ref;
  return jsx("div", {
    "data-id": "field-container",
    ref: ref,
    css: getFieldContainerStyles(disabled, isInvalid, isFocused, readOnly),
    ...rest
  });
});
FieldContainer.displayName = 'FieldContainer';

export { FieldContainer };
//# sourceMappingURL=FieldContainer.js.map
